<template>
  <select
    class="cms-select"
    :data-type="type"
    :data-selected="selected"
    :data-initial="initial"
    v-model="selected"
    @change="onSelectionEvent(selected)"
    aria-label="Select an option"
  >
    <option
      v-for="option in dropdownOptions"
      :key="option.value"
      :value="option.value"
      :selected="option.value === selected"
      :data-selected="option.value === selected"
    >
      {{ option.content }}
    </option>
  </select>
</template>

<script setup lang="ts">
import { ref, watch, computed } from "vue";
import { CmsDocument, CmsDocumentTypes } from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";

const props = defineProps<{
  type: string;
  initial?: string | undefined | null;
}>();

const emit = defineEmits(["on-selection-event"]);

const selected = ref(props.initial || "");
const lastLoadedType = ref<string | null>(null);
const docs = ref<CmsDocument[]>([]);

const dropdownOptions = computed(() => {
  const computedOptions: { value: string; content: string }[] = [];

  computedOptions.push({
    value: "",
    content: "(None)",
  });

  docs.value.forEach((doc: any) => {
    computedOptions.push({
      value: doc.id,
      content: cms.asText(doc.data.name) || cms.asText(doc.data.title) || doc.uid || doc.id,
    });
  });

  if (selected.value && !computedOptions.some((opt) => opt.value === selected.value)) {
    computedOptions.push({
      value: selected.value,
      content: selected.value,
    });
  }

  return computedOptions;
});

const onSelectionEvent = (selectedOption: string): void => {
  emit("on-selection-event", selectedOption);
};

watch(
  () => props.type,
  (newType, oldType) => {
    lastLoadedType.value = newType;
    cms.getAll(newType as CmsDocumentTypes).then((docsRes) => {
      if (lastLoadedType.value === newType) {
        docs.value = docsRes;
      }
    });
  },
  { immediate: true },
);
</script>
